if (!customElements.get('bt-body-html-content-show-more')) {
  customElements.define(
    'bt-body-html-content-show-more',
    class BtBodyHtmlContentShowMore extends HTMLElement {
      constructor() {
        super();
        this.handleToggle = this.handleToggle.bind(this);
      }

      connectedCallback() {
        this.content = this.querySelector('[data-body-html-content]');
        this.toggleButton = this.querySelector('[data-body-html-toggle]');
        this.readMoreLabel = this.querySelector('[data-label="read-more"]');
        this.readLessLabel = this.querySelector('[data-label="read-less"]');

        if (!this.content || !this.toggleButton || !this.readMoreLabel || !this.readLessLabel) return;

        this.toggleButton.addEventListener('click', this.handleToggle);
        this.classList.add('is-ready');

        if (typeof ResizeObserver !== 'undefined') {
          this.resizeObserver = new ResizeObserver(() => this.updateOverflow());
          this.resizeObserver.observe(this.content);
        }

        this.updateOverflow();
      }

      disconnectedCallback() {
        if (this.toggleButton) this.toggleButton.removeEventListener('click', this.handleToggle);
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      handleToggle() {
        const isExpanded = this.classList.toggle('is-expanded');
        this.toggleButton.setAttribute('aria-expanded', String(isExpanded));
        this.readMoreLabel.hidden = isExpanded;
        this.readLessLabel.hidden = !isExpanded;

        if (!isExpanded) this.updateOverflow();
      }

      updateOverflow() {
        const hasOverflow = this.content.scrollHeight > this.content.clientHeight + 1;
        this.classList.toggle('has-overflow', hasOverflow);
        this.toggleButton.hidden = !hasOverflow && !this.classList.contains('is-expanded');
      }
    }
  );
}
